import { client } from './client';
import type { ApiResponse } from '@/types/api';
import type { FunnelStageResponse } from '@/types/tags';

export async function getCarmaProgression(): Promise<FunnelStageResponse[]> {
  const { data } = await client.get<ApiResponse<FunnelStageResponse[]>>(
    '/api/v1/funnels/carma_progression',
  );
  return data.data ?? [];
}

export async function setUserStage(
  userId: string,
  stageSlug: string,
  reason?: string,
): Promise<void> {
  await client.post(`/api/v1/users/${userId}/stage`, {
    stage_slug: stageSlug,
    reason,
  });
}

export async function evaluateUser(userId: string): Promise<void> {
  await client.post(`/api/v1/users/${userId}/evaluate`);
}
